<style lang="scss">
  @import '../resources/scss/new_thumbnail.scss';
</style>

<script lang="ts">
  import { locale } from 'svelte-i18n'
  import type { DocumentListStructureItemsInner } from '../api/rest/backoffice-data/generated/models/DocumentListStructureItemsInner'
  import type News from '../api/rest/directus-cms/news/model/News'
  import { Constants } from '../config/constants'
  import { Slugs } from '../config/slugs'
  import { routes } from '../stores/stores'
  import NewThumbnailProjectNameDate from './New_Thumbnail_Project_Name_Date.svelte'
  import ArrowRight from './svgs/ArrowRight.svelte'

  export let isFirstRow: boolean | undefined = false
  export let newItem: DocumentListStructureItemsInner
  export let newsLabelsData: News

  let parsedImage = { ...newItem.resource } as { featuredImage: string }
  let publicationDate = newItem.publicationDate ?? undefined

  let lang = $locale ?? String(process.env.LOCALE)
  let r = `${lang}${Constants.DOUBLE_BARS}${Slugs.News}`
  let newTranslation = newItem.translations?.at?.(-1)
</script>

<div
  class="new-thumbnail position-relative h-100"
  class:new-thumbnail-first-row={isFirstRow}
>
  <div
    class="new-thumbnail-image"
    style="background-image: url('{parsedImage.featuredImage}')"
  />
  <div class="row pt-4 pb-3">
    <div class="col-12">
      <NewThumbnailProjectNameDate {publicationDate} />
    </div>
  </div>
  <div class="row new-thumbnail-text-container">
    {#if newTranslation}
      <div class="col-12 pb-3 new-title-container">
        <h4 class="mb-0">{newTranslation.title}</h4>
      </div>
      <div class="col-12 text-neutral-b new-description-container">
        {@html newTranslation.body}
      </div>
    {/if}
  </div>
  <a
    href="{$routes.get(r)}{$routes.get(
      r.replace(Slugs.News, Slugs.Show_News)
    )}{Constants.SLASH}{newItem.id}"
    class="button text-neutral-a read-more-btn d-flex position-absolute end-0 bottom-0"
  >
    {newsLabelsData.read_more}
    <div class="stroke-svg"><ArrowRight /></div>
  </a>
</div>
